/**
 * 尺を明示指定しないときの BGM 既定尺の下限 (秒)。
 * 動画エディタでトリム・ループ・分割できるため、想定尺/シーン合計が短くても余裕を持って生成する。
 * backend bgm_generator.BGM_DEFAULT_MIN_SECONDS と揃える。
 */
export const BGM_DEFAULT_MIN_SECONDS = 30;

/** 想定尺・シーン合計から BGM 既定尺 (秒) を決める。30秒未満は30秒へ切り上げ、それ以上はそのまま合わせる。 */
export function toBgmDefaultLengthSeconds(totalSeconds: number): number {
  return Math.max(BGM_DEFAULT_MIN_SECONDS, Math.round(totalSeconds));
}
